export default class LogoAnimationBtn {
	constructor(btn, home) {
		this.btn = btn;
		this.home = home;

		this.btn.addEventListener('mouseenter', this.mouseenter.bind(this));
		this.btn.addEventListener('mouseleave', this.mouseleave.bind(this));

		this.animation = this.btn.getAttribute('data-animation');
	}

	mouseenter(e) {
		this.home.areas.forEach((area) => {
			area.show(this.animation);
		});
	}

	mouseleave(e) {
		this.home.areas.forEach((area) => {
			area.show(null);
		});
	}
}
